import { render, staticRenderFns } from "./synopsis.vue?vue&type=template&id=18c61366&scoped=true"
import script from "./synopsis.vue?vue&type=script&lang=js"
export * from "./synopsis.vue?vue&type=script&lang=js"
import style0 from "./synopsis.vue?vue&type=style&index=0&id=18c61366&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c61366",
  null
  
)

export default component.exports